// Load Balancer sub-pages. Each renders inside ClusterShell (CommandBar +
// RenderDrawer + the cluster query) so stats and Render & Reload stay visible
// while the operator edits any section:
//
//   /cluster/routing   — public routing, release origin, basic auth, manager UI
//   /cluster/security  — TLS mode + origin lock (Security & access)
//
// /cluster itself redirects to /cluster/routing (see App.tsx). There is no
// /cluster/pool any more: the workers it listed and the load-balancer config it
// edited were the same rows the /workers page reads, so one inventory owns both.

import { ClusterShell } from "./layout";
import { ConfigPanel, TlsSecurityCard } from "./settings-tab";

export function ClusterRouting() {
	return (
		<ClusterShell>
			{({ cluster, stats, canEdit }) => (
				<ConfigPanel
					key={cluster.updatedAt}
					cluster={cluster}
					canEdit={canEdit}
					geoWarnings={stats?.geoWarnings}
				/>
			)}
		</ClusterShell>
	);
}

export function ClusterSecurity() {
	return (
		<ClusterShell>
			{({ cluster, canEdit }) => (
				<TlsSecurityCard cluster={cluster} canEdit={canEdit} />
			)}
		</ClusterShell>
	);
}
